const $ = window.jQuery

import utils from './utils'

const noticeCloseHandle = function(e) {
  utils.setCookie('notice-dismissible-' + $(this).attr('data-notice-close'), true, 1)
  $(this).parents('.is-c24-inline-notice-dismissible').hide()
}

const init = function() {
  $('.is-c24-inline-notice-dismissible').each(function(index, item) {
    const $dismissButton = $(item).find('[data-notice-close]').first()
    if ($dismissButton.length) {
      if(utils.getCookie('notice-dismissible-' + $dismissButton.attr('data-notice-close')) !== 'true') {
        $(item).show()
      }
    }
  })

  $('[data-notice-close]').on('click', noticeCloseHandle)
}

const destroy = function() {
  $('[data-notice-close]').off('click')
}

export default {init, destroy}